export default "__VITE_ASSET__CiscNZHk__"